module.exports = __webpack_public_path__ + "static/Bitexbook-0fda456051c656cd9ac2e8353cfbee77.png";